var emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = emailRegExp.test(value) ? undefined : 'Email address is invalid';
  if (error) return error;
  return undefined;
});